import { SwapStatus } from '@valiant/ui-shared'

/**
 * Masks retryable failures while recovery is still possible. External API trade and withdrawal
 * failures are refunded and cannot be retried, so they must remain visible as failed.
 */
export const maskSwapStatus = (
  status: string | null | undefined,
  isExternalApi = false,
): string | null | undefined => {
  if (
    isExternalApi &&
    (status === SwapStatus.TradeFailed || status === SwapStatus.WithdrawalFailed)
  ) {
    return status
  }
  if (status === SwapStatus.TradeFailed) return SwapStatus.TradeExecuting
  if (status === SwapStatus.WithdrawalFailed) return SwapStatus.WithdrawalInitiated
  if (status === SwapStatus.PushOutFailed) return SwapStatus.PushOutInitiated
  return status
}
